import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const DBTPTSDOFMN_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/dbtptsdofmn/logo.png",
        alt: "DBT & PTSD Specialists, P.A. Logo",
        style: { width: "300px", height: "100%", isMobile: { width: "200px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 2,
  state: "MN",
  departmentIds: [227, 237],
};
